module.exports = __webpack_public_path__ + "static/media/26UNRWA15.8c8c7d45.jpg";